import config from '../../../config'
import { EnrolmentFormStudies as EnrolmentFormStudiesGeneric } from './studies.generic';
import { EnrolmentFormStudies as EnrolmentFormStudiesPompeuFabra } from './studies.pompeufabra';
//import { EnrolmentFormStudies as EnrolmentFormStudiesArtLaIndustrial } from './studies.artlaindustrial';

export default function EnrolmentFormStudies(props)
{
  switch(config.cid)
  {
    // Pompeu Fabra
    case 'a8020620':
      return EnrolmentFormStudiesPompeuFabra(props)

      /*
    // Art La industrial
    case 'a8042354':
      return EnrolmentFormStudiesArtLaIndustrial(props)
      */

    default:
      return EnrolmentFormStudiesGeneric(props)
  }
}


